import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface ChartTabsProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

const ChartTabs: React.FC<ChartTabsProps> = ({ value, onValueChange, className }) => {
  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      <TabsList className="grid w-full grid-cols-2 h-7 p-0.5">
        <TabsTrigger value="cumulative" className="text-xs h-6">Cumulative</TabsTrigger>
        <TabsTrigger value="daily" className="text-xs h-6">Daily</TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default ChartTabs;